import styles from './PageContainer.module.css';
import useFetch from 'e3-common/hooks/useFetch';
import { useState, useRef, useEffect } from 'react';
import { getCommonCodeById } from 'e3-common/utils/commonCodeUtil';
import { useBoundStore } from 'e3-common/store/useBoundStore';
import PropTypes from 'prop-types';
import { HOME_MENU_ID } from 'e3-common/constants/constMenuId';
import HelpPopup from '@/pages/System/Popup/HelpPopup';
import { shallow } from 'zustand/shallow';

const PageContainer = ({ children, menuName, menuId, helpYn, menuNameList }) => {
    const { favoriteMenu, setFavoriteMenu } = useBoundStore((state) => state.menu);
    const { selectedMenu } = useBoundStore((state) => state.menu, shallow);
    //const menuNameList = useBoundStore((state) => state.menu.menuNameList);
    const stateAll = useBoundStore((state) => state);
    const [showMenuId, setShowMenuId] = useState(false);
    const [newMenuName, setNewMenuName] = useState(menuName);
    const { request } = useFetch();
    const refPopup = useRef();

    useEffect(() => {
        // const getMenuName = async (e, r, name) => {
        //   const m = r.find((x) => x.menuId === e.menuId);
        //   let lvl = m ? m.level : 0;
        //   let parent = m ? m.parentId : null;

        //   if (lvl > 1) {
        //     const m = r.find((x) => x.menuId === parent);
        //     name = m.menuName + ' > ' + name;
        //     getMenuName(m, r, name);
        //   } else {
        //     setNewMenuName(name);
        //   }
        // };

        const checkSysOpt = async () => {
            const code = await getCommonCodeById('SYSTEM_OPTION', 'SYS_OPT_SHOW_MENU_ID');
            if (code?.propStr1 === 'Y') {
                setShowMenuId(true);
            }

            // // menuName 재생성 작업 - 2024-10-25 jh.park
            // if (selectedMenu.menuId) {
            //   await getMenuName(selectedMenu, stateAll.menu.menuList, selectedMenu.menuName);
            // }
        };
        checkSysOpt();
    }, []);

    const getFavoriteMenuState = (menuId) => {
        const menuList = favoriteMenu?.reduce((pre, cur) => {
            pre.push(cur.menuId ?? cur.MENU_ID);
            return pre;
        }, []);
        return menuList?.includes(menuId);
    };

    const onSetFavorite = async (menuId) => {
        const response = await request(
            `/favorite-menu/${menuId}`,
            {
                method: 'POST',
            },
            {
                showConfirm: false,
            }
        );
        if (response) {
            const camelResponse = response?.map((x) => {
                return {
                    isActive: x.IS_ACTIVE,
                    menuId: x.MENU_ID,
                    menuName: x.MENU_NM,
                    programPath: x.PGM_PATH,
                    programRoutePath: x.ROUTING_PATH,
                };
            });
            setFavoriteMenu(camelResponse);
        }
    };

    const openPopup = () => {
        refPopup.current.showPopup(menuId);
    };

    return (
        <>
            {menuId !== HOME_MENU_ID ? (
                <h2 className={styles.pageTitle}>
                    {menuId && menuName ? (
                        <>
                            <div className={styles.pageTitle_txt}>
                                {menuNameList}
                                <span>{showMenuId && ` (${menuId})`}</span>
                            </div>
                            <div className={styles.pageTitle_icon}>
                                {helpYn === 'Y' && (
                                    <span className={styles.help} onClick={openPopup}>
                                        도움말<em className={styles.tooltip}>도움말</em>
                                    </span>
                                )}
                                {helpYn === 'Y' && <span className={styles.pageTitle_bar}></span>}
                                <span
                                    className={`${styles.favorite} ${
                                        getFavoriteMenuState(menuId) && styles.selected
                                    }`}
                                    onClick={() => {
                                        onSetFavorite(menuId);
                                    }}
                                >
                                    즐겨찾기
                                    <em className={styles.tooltip}>즐겨찾기</em>
                                </span>
                            </div>
                        </>
                    ) : null}
                </h2>
            ) : null}
            {children}
            <HelpPopup ref={refPopup} />
        </>
    );
};

PageContainer.propTypes = {
    children: PropTypes.node,
    menuName: PropTypes.string,
    menuId: PropTypes.string,
    menuNameList: PropTypes.string,
};
PageContainer.displayName = 'PageContainer';
export default PageContainer;
